module.exports = __webpack_public_path__ + "static/shenhe-banner-e4bb0adecc1edfdd7de2ceae0446d115.png";